// Requests written as plain text (the Create form before 2026-09-23, and any
// API caller) have no markup, and tiptap collapses their line breaks into one
// run-on paragraph. Plain text is turned into paragraphs; HTML is untouched.
const escapeHtml = (t) => t.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
export const asHtml = (value) => {
    const v = value || '';
    if (!v.trim() || /<[a-z][\s\S]*>/i.test(v)) return v;
    return v.trim().split(/\n{2,}/).map((p) => `<p>${escapeHtml(p).replace(/\n/g, '<br>')}</p>`).join('');
};
